export const TASK_STATUSES = ['RESERVED', 'INPROGRESS', 'READY'];
